<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'MOBILE_USERS' }]"
></breadcrumbs>

<page-header title="MOBILE_USERS"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getPagination('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getPagination('page')"
  [sort]="getPagination('sort')"
  [orderBy]="getPagination('order_by')"
  [columns]="columns"
  [filters]="filters"
  (onFilterChange)="handleFilterChange($event)"
  [showFilter]="true"
  [showReload]="true"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_USER"
        >{{ 'CREATE_MOBILE_USER' | translate }}</a
      >
    </div>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <alert #deleteAlert (confirm)="deleteUser(row.get('id'))" titleTrnKey="ARE_YOU_SURE" textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS" />
    <div class="buttons">
      <a
        [routerLink]="[row.get('id'), 'tasks']"
        class="button is-small is-primary"
        translationEditableDirective="TASKS"
        >{{ 'TASKS' | translate }}</a
      >
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template let-row="row" let-index="index" #zones>
    <span
      *ngIf="!row.get('layerFeatures').size"
      translationEditableDirective="NONE"
    >
      {{ 'NONE' | translate }}
    </span>
    <div
      class="dropdown is-hoverable is-up"
      *ngIf="!!row.get('layerFeatures').size"
    >
      <span
        class="dropdown-trigger is-block has-text-centered"
        aria-haspopup="true"
        aria-controls="dropdown-menu5"
        >{{ row.get('layerFeatures').size }}</span
      >
      <div
        class="dropdown-menu"
        id="dropdown-menu5"
        role="menu"
        style="left: 300% !important; min-width: initial"
        [ngStyle]="{
          top:
            index === state.get('filtered') - 1
              ? 'initial'
              : index === state.get('filtered') - 2
              ? -50 + 'px'
              : -25 + 'px',
          bottom: index !== state.get('filtered') - 1 ? 'initial' : -5 + 'px'
        }"
      >
        <div class="dropdown-content p-0">
          <div class="dropdown-item p-1 px-2">
            <div class="">
              <ul
                class="p-0 m-0"
                style="list-style-type: none; line-height: 1.2"
              >
                <li
                  *ngFor="let feature of row.get('layerFeatures').toJS()"
                  style="font-size: 12px"
                >
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template let-row="row" let-index="index" #suspended>
    <span [translationEditableDirective]="row.get('suspended') ? 'YES' : 'NO'">
      {{ (row.get('suspended') ? 'YES' : 'NO') | translate }}
    </span>
  </ng-template>

  <ng-template let-row="row" let-index="index" #mode>
    <span
      [translationEditableDirective]="row.getIn(['mode', 'translationKey'])"
    >
      {{
        row.getIn(['mode', 'translationKey'])
          | translate : { defaultValue: row.getIn(['mode', 'title']) }
      }}
    </span>
  </ng-template>
</app-table>
